import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const messages = {
  fr: {
    slogan: "Notre ambition, la réussite de vos projets !",
    tagline: `Votre <span class="partenaire">Partenaire</span> en Management de projet`,
    welcome: "Bienvenue chez FGFconsultant, votre source fiable pour des solutions de conseil, de formation et de recherche en gestion de projets. Notre équipe d'experts est à votre disposition pour vous guider vers la réussite de vos projets.",
    contact_us: "Contactez-nous !",
    services: "Les services que nous offrons",
    services_subtitle:"Des services sur mesure pour piloter et concrétiser vos ambitions",
    collaborations: "Collaborations qui font la différence",
    success_story: "Notre Histoire de Succès à Travers les Partenariats",
    partners_space: "Bienvenue dans notre espace dédié aux partenaires qui ont choisi d'évoluer avec nous. Cette galerie de logos représente bien plus que des collaborations passées; elle incarne des relations solides et durables.",
    explore_projects: "Explorer Nos Projets à Travers le Monde",
    discover_map: "Découvrez la Portée Internationale de FGFconsultant avec Notre Carte Interactive",
    why_fgf: "Pourquoi",
    commitment: "Chez FGFconsultant, nous nous engageons à simplifier votre gestion de projet et à booster la croissance de votre entreprise. Notre expertise de longue date, nos logiciels de pointe et notre engagement envers votre succès en font le partenaire idéal. Avec nous, la gestion de projet devient un jeu d'enfant, et votre réussite devient notre mission. Rejoignez-nous dès aujourd'hui pour transformer votre entreprise.",
    proven_expertise: "Expertise Éprouvée",
    cutting_edge_software: "Logiciels de Pointe",
    full_transparency: "Transparence Totale",
    custom_training: "Formation Personnalisée",
    dedication_success: "Engagement envers Votre Succès",
    your_goals: "Et vous, quels sont vos objectifs ?",
    questions: "Des Questions ?",
    footer_tagline: "FGFconsultant : Simplifiez la gestion de projet, stimulez la croissance de votre entreprise, et faites de nous votre partenaire pour le succès.",
    address: "Adresse",
    email: "Email",
    phone: "Numéro de téléphone",
    legal: "Mentions légales",
    sitemap: "Plan du site",
    conseil: "Conseil",
    formation: "Formation",
    recherche: "Recherche",
    liberte: "Liberté",
    voyage: "Voyage",
    creativite: "Créativité",
    sport: "Sport",
    contactez_nous: "Contactez-nous",
    title: "Contactez-nous pour concrétiser vos idées !",
    description: "Nous sommes à votre écoute pour répondre à toutes vos questions et donner vie à vos projets.",
    subText: "Laissez-nous vous aider à atteindre vos objectifs.",
    send: "Envoyer",
    lastName: "Nom",
    firstName: "Prénom",
    message: "message",
    items: [
      {
        id: 1,
        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 26 26"><!-- Icon from Icons8 Windows 8 Icons by Icons8 - undefined --><path fill="currentColor" d="M12 0C6.412 0 1.248 3.477 2.219 11.75c-.173.138-.34.286-.469.469c-.503.71-.75 1.633-.75 2.625c0 1.245.734 2.203 1.5 2.906c.56.515 1.133.874 1.781 1.063c.51 1.64 1.449 3 2.563 3.937a1 1 0 1 0 1.281-1.531c-1.006-.847-1.847-1.978-2.156-3.438A1 1 0 0 0 5 17c.123 0-.646-.25-1.156-.719S3 15.226 3 14.844c0-.464.111-.852.25-1.156A1 1 0 0 0 5 13v-.844a1 1 0 0 0 0-.094q.06-1.069.281-1.968C6.66 9.62 7.808 10.389 9 6.875c1.74 5.173 6.246 2.214 9.344 2.063c.364.885.59 1.925.656 3.124a1 1 0 0 0 0 .094V13a1 1 0 0 0 1 1v2.469c-.434.341-.915.531-1 .531a1 1 0 0 0-.969.781c-.204.966-.658 1.779-1.218 2.469a1.01 1.01 0 1 0 1.562 1.281c.6-.739.998-1.706 1.313-2.718A4.2 4.2 0 0 0 21.313 18H22c-.245 1.281-.696 2.248-1.156 2.938c-.65.975-1.21 1.316-1.25 1.343c-.029.015-.384.21-1.407.438c-.78.173-1.903.358-3.406.437c-.201-1.115-1.369-1.968-2.781-1.968c-1.554 0-2.813 1.035-2.813 2.312s1.26 2.313 2.813 2.313c.971 0 1.838-.416 2.344-1.032c1.85-.074 3.256-.286 4.219-.5c1.186-.263 1.78-.562 1.78-.562a1 1 0 0 0 .095-.063s.892-.605 1.718-1.843c.668-1.002 1.33-2.455 1.563-4.375c.728-.545 1.187-1.436 1.187-2.438v-2c0-1.657-1.25-3-2.906-3h-.156C21.848 3.002 17.174 0 12 0m8.656 9.875c.03.042.065.08.094.125h-.094c-.008-.041.009-.084 0-.125M8 12a2 2 0 1 0 0 4a2 2 0 0 0 0-4m8 0a2 2 0 1 0 0 4a2 2 0 0 0 0-4"/></svg>',
        title: "Assistance Technique",
        content: `
          <ul>
            <li>Maitrise des délais/planification</li>
            <li>OPC (Organisation, Pilotage et Coordination)</li>
            <li>Maitrise des dépenses/Coutenance</li>
            <li>Maitrise des risques (Risk Manager)</li>
            <li>Maitrise du processus de développement du produit</li>
            <li>Maitrise globale en tant que chef de projet</li>
          </ul>`
      },
      {
        id: 2,
        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 26 26"><!-- Icon from Icons8 Windows 8 Icons by Icons8 - undefined --><path fill="currentColor" d="M16.563 15.9c-.159-.052-1.164-.505-.536-2.414h-.009c1.637-1.686 2.888-4.399 2.888-7.07c0-4.107-2.731-6.26-5.905-6.26c-3.176 0-5.892 2.152-5.892 6.26c0 2.682 1.244 5.406 2.891 7.088c.642 1.684-.506 2.309-.746 2.396c-3.324 1.203-7.224 3.394-7.224 5.557v.811c0 2.947 5.714 3.617 11.002 3.617c5.296 0 10.938-.67 10.938-3.617v-.811c0-2.228-3.919-4.402-7.407-5.557m-5.516 8.709c0-2.549 1.623-5.99 1.623-5.99l-1.123-.881c0-.842 1.453-1.723 1.453-1.723s1.449.895 1.449 1.723l-1.119.881s1.623 3.428 1.623 6.018c0 .406-3.906.312-3.906-.028"/></svg>',
        title: "Coaching de Chef de Projet",
        content: `
          <ul>
            <li>Maitrise d'œuvre</li>
            <li>Maitrise d'ouvrage</li>
          </ul>`
      },
      {
        id: 3,
        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512"><!-- Icon from Font Awesome 5 Solid by Dave Gandy - https://creativecommons.org/licenses/by/4.0/ --><path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256S119.033 8 256 8s248 111.033 248 248M227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001"/></svg>',
        title: "Amélioration de vos pratiques",
        content: `
          <ul>
            <li>Audit des process et indication des modifications à réaliser</li>
            <li>Mise en place de process et de la documentation associée</li>
            <li>Sélection d’outil logiciel ou pilotage du développement d’outils</li>
            <li>Mise en place de logiciels, interfaces, formations</li>
          </ul>`
      },
      {
        id: 4,
        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512"><!-- Icon from Font Awesome 5 Solid by Dave Gandy - https://creativecommons.org/licenses/by/4.0/ --><path fill="currentColor" d="M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16M464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96l32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16"/></svg>',
        title: "Conduite de votre projet",
        content: `
          <ul>
            <li>Maître d’œuvre</li>
            <li>Architecte industriel</li>
            <li>Maître d’ouvrage délégué</li>
            <li>Assistant à maître d’ouvrage</li>
          </ul>`
      },
      {
        id: 5,
        svg: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512"><!-- Icon from Font Awesome 5 Solid by Dave Gandy - https://creativecommons.org/licenses/by/4.0/ --><path fill="currentColor" d="M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96s42.98 96 96 96s96-42.98 96-96M233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05c43.66 2.29 131.99 10.68 193.04 41.43c9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46m248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05c-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9c61.04-30.72 149.32-39.11 192.97-41.4c14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09"/></svg>',
        title: "Formation Chef de Projet",
        content: `
          <ul>
            <li>Management de Projet : connaissances fondamentales (4 jours)</li>
            <li>Le métier de Chef de Projet (4 jours)</li>
            <li>Management de Projet : rôle de la maîtrise d’ouvrage (2 jours)</li>
          </ul>`
      },
      {
        id: 6,
        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512"><!-- Icon from Font Awesome 5 Solid by Dave Gandy - https://creativecommons.org/licenses/by/4.0/ --><path fill="currentColor" d="M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96s42.98 96 96 96s96-42.98 96-96M233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05c43.66 2.29 131.99 10.68 193.04 41.43c9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46m248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05c-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9c61.04-30.72 149.32-39.11 192.97-41.4c14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09"/></svg>',
        title: "Formation en Management de Projet",
        content: `
          <ul>
            <li>La Maîtrise des Délais des Projets / Planification (4 jours)</li>
            <li>La Maîtrise des Coûts des Projets / Coûtenance (4 jours)</li>
            <li>Estimation des coûts en maîtrise d’œuvre et d’ouvrage (4 jours)</li>
            <li>L’estimation des coûts côté maîtrise d’œuvre (3 jours)</li>
            <li>L’évaluation économique des projets (2 jours)</li>
            <li>La Maîtrise des Risques des Projets (2 jours)</li>
            <li>La Maîtrise du Développement du produit du Projet (3 jours)</li>
            <li>L’expression des besoins dans les projets (2 jours)</li>
          </ul>`
      },
      {
        id: 7,
        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512"><!-- Icon from Font Awesome 5 Solid by Dave Gandy - https://creativecommons.org/licenses/by/4.0/ --><path fill="currentColor" d="M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96s42.98 96 96 96s96-42.98 96-96M233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05c43.66 2.29 131.99 10.68 193.04 41.43c9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46m248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05c-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9c61.04-30.72 149.32-39.11 192.97-41.4c14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09"/></svg>',
        title: "Formation Conduite de Projet",
        content: `
          <ul>
            <li>La conduite des grands projets (5 jours)</li>
            <li>Petits projets : ce qu’il faut faire pour réussir (2 jours)</li>
          </ul>`
      },
      {
        id: 8,
        svg:'<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512"><!-- Icon from Font Awesome 5 Solid by Dave Gandy - https://creativecommons.org/licenses/by/4.0/ --><path fill="currentColor" d="M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96s42.98 96 96 96s96-42.98 96-96M233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05c43.66 2.29 131.99 10.68 193.04 41.43c9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46m248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05c-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9c61.04-30.72 149.32-39.11 192.97-41.4c14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09"/></svg>',
        title: "Formation aux outils logiciels de gestion de projet",
        content: `
          <ul>
            <li>Utiliser MS Project : 3 niveaux (débutant, confirmé, expert), 2 jours par niveau</li>
            <li>Utiliser Primavera : 3 niveaux (débutant, confirmé, expert), 2 jours par niveau</li>
            <li>Utiliser Sciforma : 3 niveaux (débutant, confirmé, expert), 2 jours par niveau</li>
          </ul>`
      }
    ],

    conseilSection: {
      title: "Conseil - Des résultats concrets",
      description:
        "Nous optimisons le management de vos projets en vous apportant des solutions adaptées à vos besoins.",
      subtitle: "Nos Expertises en conseil",
      expertises: [
        {
          id: 1,
          title: "Optimisation des processus",
          content: "Structuration et amélioration des méthodes de conduite de vos projets."
        },
        {
          id: 2,
          title: "Digitalisation et outils",
          content:
            "Déploiement de logiciels et de solutions digitales pour un management plus performant et une réduction de vos coûts."
        },
        {
          id: 3,
          title: "Accompagnement opérationnel",
          content:
            "Soutien aux équipes projet dédiées et aux PMO pour le pilotage de vos projets."
        },
        {
          id: 4,
          title: "Conduite de projet",
          content:
            "Prise en charge de la maîtrise d’œuvre et conduite de vos projets sur le terrain, assistance à maîtrise d’ouvrage auprès de votre entreprise ou collectivité publique."
        }
      ],
      missionsTitle: "Quelques missions",
      missions: [
        {
          id: 1,
          content: "Amélioration des processus de gestion de projet pour une société de service (8000 pers.)",

        },
        {
          id: 2,
          content: "Mise en place d’un référentiel projet pour une entreprise aéronautique.",
        },
        {
          id: 3,
          content: "Optimisation de la gestion documentaire dans le secteur du nucléaire.",
        },
        {
          id: 4,
          content: "Déploiement d’outils de pilotage et formation des équipes pour un groupe industriel.",
        },
        {
          id: 5,
          content: "Assistance à maîtrise d’ouvrage sur plusieurs projets complexes.",
        },
        {
          id: 6,
          content:"Maitrise d’oeuvre de plusieurs projets",
        }

      ],

      secteur: "Secteurs d'interventions les plus fréquents",
      quote: "Vous avez des questions ? N'hésitez surtout pas à nous le faire savoir",

      Conseil: [
        {
          id: 1,
          title: "Mise en place ou amélioration du processus de conduite de projet",
          content: `<p>L'un des grands défis de la fin du deuxième millénaire a été de doter les peuples des pays dits 'développés' d'un ensemble d'équipements et de biens destinés à améliorer leur qualité de vie : meilleure nutrition, plus de bien-être, plus d'hygiène, plus de santé, plus de loisirs, et donc une plus grande ouverture sur le monde, l'humain, le social, notre planète, l'écologie... Pour faire face à ce défi, l'ensemble des institutions s'est organisé et a donné naissance à une nouvelle forme de gestion adaptée aux activités répétitives et durables. Mais en raison de grands projets dans le spatial, le nucléaire, le médical, puis avec l'accélération du renouvellement des produits de série, le besoin de gérer des projets est réapparu. De plus, avec l'apparition de l'informatique au milieu du 20ème siècle et la possibilité de stocker et de traiter de grandes quantités de données avec une bonne productivité, un nouveau mode de conduite de projet s'est développé. De nombreux organismes se trouvent actuellement confrontés, en ce début du troisième millénaire, à des difficultés liées à ce décalage entre l'organisation en place adaptée aux activités répétitives et durables, et le besoin d'un mode de gestion moderne adapté aux activités de type projet.</p>
          <p>FGFconsultant est spécialisé dans le conseil en Re-ingénierie. À partir de l'audit de votre organisation et en fonction de vos besoins et spécificités managériales, conformément à vos objectifs, FGFconsultant est en mesure de conduire votre changement de type de Management et de Projet :</p>
          <ul>
            <li>Les compléments de culture et de savoir-faire nécessaires.</li>
            <li>Les nouvelles pratiques.</li>
            <li>Les nouveaux processus.</li>
          </ul>`
        },
        {
          id: 2,
          title: "Implantation ou évolution d'une solution logicielle",
          content: `<p>Le milieu du 20ème siècle a vu l’apparition de l’informatique, c’est-à-dire la possibilité de stocker et de traiter de grandes quantités de données avec une bonne productivité. Dans le domaine de la conduite de projet, cela a influencé l’évolution des processus et des pratiques, et de nouveaux outils logiciels ont vu progressivement le jour.</p>
          <p>FGFconsultant est spécialisé dans le conseil en outils digitaux de conduite de projets. À partir de l’audit de vos moyens et en fonction de vos besoins et spécificités managériales, conformément à vos objectifs, FGFconsultant est en mesure de conduire votre changement de système d'information projet en prenant en charge tout ou partie de :</p>
          <ul>
            <li>Choix des logiciels / appels d’offre</li>
            <li>Installation et paramétrage</li>
            <li>Migration et accompagnement sur projets pilotes</li>
            <li>Support en hotline</li>
          </ul>`
        },
        {
          id: 3,
          title: "Assistance à Maître d’Ouvrage et à Maîtrise d’Œuvre par apport d'une expertise",
          content: `<p>Dans l'agriculture, dans l'industrie, mais aussi très largement dans le domaine des services, tous les organismes sont aujourd'hui confrontés à des projets qui nécessitent une gestion efficace.</p>
          <p>En même temps, surtout lorsque l'objectif principal des organismes est de produire en série, les ressources nécessaires à la gestion de projets font souvent défaut ou sont insuffisantes.</p>
          <p>FGFconsultant peut prendre en charge l'une des composantes telles que la maîtrise de la configuration, des délais, des coûts, des risques et de la communication. FGFconsultant peut aussi prendre en charge l'ensemble du contrôle de projet auprès de votre chef de projet, ou même gérer l'intégralité de votre projet. Enfin, FGFconsultant, de par son expertise en management de projet, sait "coacher" vos responsables pour que tout leur potentiel soit mis au service de vos projets.</p>`
        },
        {
          id: 4,
          title: "Maîtrise d’Œuvre de projet FGFconsultant",
          content: `<p>Le management de projet est à la fois un art et une science. Il est adapté aux projets, à leurs spécificités et est soumis aux lois qui régissent leurs caractéristiques; en cela, c'est une science, et il n'est pas possible, aujourd'hui, d'avoir un management pertinent sans connaître ces lois.</p>
          <p>Cependant, parce que la plupart des projets font appel à de très nombreux domaines tels que les sciences humaines, les relations commerciales, les règles juridiques, le respect de la collectivité et de l'environnement, l'intégration dans un système supérieur, l'harmonie culturelle, etc., le management de projet est aussi un art.</p>
          <p>Manager un projet ou en assurer le contrôle sont donc des responsabilités à la fois passionnantes, délicates et difficiles. FGFconsultant prend en charge la globalité de la conduite du projet, du début à la fin du projet ou sur une phase particulière, soit en tant que Maître d'œuvre, soit en tant qu'Assistant à Maître d'ouvrage.</p>`
        }
      ],

    },

    formationSection: {
      title: "Formation - Des compétences clés",
      description:
        "Nous concevons et animons des formations adaptées à vos besoins, que vous soyez une entreprise ou un service public, une grande école, une université ou un organisme de formation continue.",
      subtitle: "Nos Formations en action",
      formations: [
        {
          id: 1,
          title: "Enseignement des méthodes",
          content: "Formation aux bonnes pratiques de conduite de projet."
        },
        {
          id: 2,
          title: "Formation aux outils",
          content: "Apprentissage de l’utilisation de logiciels spécialisés."
        },
        {
          id: 3,
          title: "Formation initiale & continue",
          content: "Intervention en grandes écoles et universités, entreprises et services publics, centres de formation professionnelle continue."
        },
        {
          id: 4,
          title: "Ingénierie pédagogique & animations",
          content: "Création de contenu : cours magistraux, études de cas, mises en situation. Animation des séquences créées, simulations de projet, préparation à des certifications internationales."
        }
      ],
      themesTitle: "Quelques thèmes enseignés",
      teachingTopics: [
        {
          content: "Fondamentaux du management de projet Méthodologie - organisation et communication (3 à 6 jours)"
        },
        {

          content: "Estimation des coûts et évaluation de la rentabilité - Base de données, méthodes d’estimation et calcul de la VAN (3 à 5 jours)"
        },
        {

          content: "Certifications internationales - Préparation aux certifications PMI, IPMA et ICEC (5 à 20 jours)"
        },
        {
          content: "Maîtrise des dépenses - Budget, valeur acquise et reste à faire (3 à 5 jours)"
        },
        {
          content: "Solutions logicielles de gestion de projet - Formation sur des outils spécialisés (2 à 3 jours)"
        },
        {
          content: "Gestion des risques - Analyse et maîtrise, budget de contingence et provision (1 à 3 jours)"
        }
      ],
      secteur: "Ils nous ont invités",
      quote: "Vous avez des questions ? N'hésitez surtout pas à nous le faire savoir",

      Formation: [
        {
          id: 1,
          title: "Enseignement des méthodes et du relationnel en management de projet",
          content: `<p> Depuis le milieu du 20e siècle, avec le besoin de conduire de grands projets dans le spatial, le nucléaire, le médical, puis avec l'accélération du renouvellement des produits de série et le développement de l'informatique, de nouveaux modes de conduite de projet se sont développés : structuration du projet, méthodes d'estimation et d'analyse de risques, organisations et contrats, identification des besoins et construction des performances, systèmes d'information et de prise de décisions, maîtrise des coûts (coûtenance), des délais (planification), des risques (risk management) et des acteurs, provisions et marges. FGFconsultant, spécialiste du management de projet, propose des formations dans tous ces domaines.
          </p>`
        },
        {
          id: 2,
          title: "Apprentissage de l'utilisation de solutions logicielles",
          content: `<p>Depuis le milieu du 20e siècle, des outils d’aide à la conduite de projet ont été développés. D’abord orientés sur l’organisation des différentes tâches dans le temps, les applications disponibles permettent maintenant de contrôler l’ensemble des paramètres à maîtriser pour réussir les projets. FGFconsultant maîtrise plusieurs logiciels parmi les plus performants et assure des formations à leur utilisation en combinant la connaissance des outils avec son expertise en conduite de projet.</p>`
        },
        {
          id: 3,
          content: `
          <ul>
          <li> <strong>Formation initiale </strong> dans les grandes écoles et universités francophones.</li>
          <li><strong>Formation Continue inter-entreprise </strong>pour les organismes spécialisés.</li>
          <li><strong>Formation Continue intra-entreprise </strong>, dans les entreprises et les collectivités.</li>
          <li><strong>Formation individuelle </strong>, sur mesure.</li>
          </ul>
          <p>Dans tous les secteurs d'activités, les performances économiques des organismes et des entreprises sont de plus en plus liées aux résultats de leurs projets. Pour faire face à cette réalité, il est de plus en plus recherché du personnel qualifié en management de projet.
              Ainsi, les universités, les grandes écoles et les organismes de formation continue intègrent des modules de formation en management de projet dans leurs programmes. Les entreprises et les organismes publics sont également amenées à créer des formations internes (formation "intra") pour leurs employés.
              FGFconsultant adapte ses formations en management de projet en fonction de vos besoins et de vos objectifs, en tenant compte de la culture de vos étudiants ou stagiaires. Nous proposons des formations spécialisées de haute qualité pour répondre à la demande croissante de compétences en gestion de projet.`
        },
        {
          id: 4,
          title: "Ingénierie pédagogique et animations. Simulation de projet, accompagnement, diplômes et certitications internationale",
          content: `<p>FGFconsultant, expert en management de projet, crée puis anime des formations sur l'ensemble de ce domaine d'expertise. Afin de renforcer l'assimilation de ces formations, FGFconsultant propose aussi des simulations de projet qui permettent aux stagiaires de se retrouver en situations réelles. FGFconsultant propose également un accompagnement post-formation afin d'aider les stagiaires à manager leurs propres projets. Enfin, FGFconsultant offre des formations à plusieurs certifications internationales pour permettre aux personnes et à leurs entreprises de se positionner en experts reconnus.</p>`

        }
      ],

    },
    researchSection: {
      title: "Recherches - Des avancées significatives",
      description:
        "Nous utilisons notre expertise pour améliorer les méthodes et les outils de management de projet et améliorons ainsi en continu les conseils et les formations que nous vous offrons.",
      subtitle: "Recherche et innovation au cœur de nos actions",
      items: [
        {
          id: 1,
          title: "Innovation en management de projet",
          content: "Pionniers dans le domaine, nous développons de nouvelles méthodes pour relever les défis de demain."
        },
        {
          id: 2,
          title: "Renforcement des outils méthodologiques",
          content: "Nos solutions permettent d’optimiser vos processus, réduire vos coûts et maximiser vos résultats."
        },
        {
          id: 3,
          title: "Création d'outils digitaux sur mesure",
          content: "Nous concevons des logiciels innovants pour simplifier la gestion et le suivi de vos projets."
        },
        {
          id: 4,
          title: "Optimisation des organisations",
          content: "Évaluation des solutions rencontrées, élaboration et test de solutions alternatives en partenariat avec de grandes écoles et universités."
        }
      ],
      workTitle: "Quelques travaux réalisés",
      works: [
        { content: "Élaboration d’une méthode optimisée de maîtrise des dépenses projet. Plus réactive, moins coûteuse, plus pertinente." },
        { content: "Mise au point du Système Documentaire Projet (SDP). Liste exhaustive des documents, sommaires des documents. Moins de modifications dans les projets, donc moins coûteux et plus courts." },
        { content: "Développement d’un logiciel de maîtrise des actions et des décisions. Management, communication et traçabilité améliorés. Moins d’erreurs, plus de qualité." },
      ],
      invitedTitle: "Ils nous ont invités",
      quote: "Vous avez des questions ? N'hésitez surtout pas à nous le faire savoir",
      Recherche: [
        {
          id: 1,
          title: "Pionner, FGFconsultant écrit déjà l'avenir du Management du Projet",
          content: `<p>FGFconsultant joue un rôle actif au sein de divers groupes de travail regroupant des experts en management de projet, ayant pour objectif de mieux comprendre les spécificités des projets et de concevoir des solutions plus efficaces pour leur gestion.
François Gagné, président-fondateur de FGFconsultant, a notamment présidé le groupe d'experts qui, en collaboration avec l'AFNOR (Association Française de " Normalisation) et l'AFITEP (Association Francophone du Management de Projet), a élaboré en 2004 et 2005 le "fascicule documentaire" X 50-137 sur la maîtrise des coûts des projets. Ce document constitue la référence française en matière de maîtrise des coûts dans le domaine de la gestion de projet.
En tant que trait d'inion naturel entre le monde enseignant, grâce à ses activités de formation, et le monde opérationnel, grâce à ses activités de conseil, FGFconsultant assure l'encadrement de mémoires de deux manières : soit en mettant à disposition un directeur de recherche auprès d'universités et de grandes écoles, soit en accueillant des stagiaires au sein de son équipe.</p>`
        },
        {
          id: 2,
          title: "Amélioration de l'arsenal méthodologique de Management de Projet",
          content: `<p>Le Management de Projet est, par définition, le management adapté à l'activité productive de type projet. Alors que le management dominant du 20ème siècle, destiné à l'optimisation des activités répétitives et pérennes, a fait l'objet de nombreux développements, le Management de Projet a encore un périmètre incertain et est à la recherche d'une cohérence d'ensemble. FGFconsultant participe activement aux travaux de structuration d'un Management de Projet pragmatique et efficace.
Cette approche globale n'a d'utilité opérationnelle que si elle est accompagnée de solutions performantes pour traiter les différentes composantes du Management de Projet. Aussi, FGFconsultant participe à l'élaboration d'outils méthodologiques spécifiques, tels que des arborescences de produit et d'acteurs, ainsi que des solutions de maîtrise des délais, entre autres.
Les travaux les plus avancés portent sur la maîtrise des coûts des projets. Afin d'améliorer la performance économique du projet et donc des différents acteurs, et plus largement de la "collectivité" qui bénéficie de la diminution des gaspillages, FGFconsultant a mis au point une méthode optimisée permettant de maîtriser les dépenses faites au cours de la phase de réalisation d'un projet: la méthode FGF de coûtenance. Cette méthode simple, économique et réactive permet de respecter les choix stratégiques relatifs à la décision de lancement du projet, réduisant ainsi les incertitudes économiques à un niveau minimal. Parfaitement opérationnelle, elle s'applique aisément à tout type de projet.</p>`
        },
        {
          id: 3,
          title: "Développement de solutions logicielles qui complètent l'offre actuelle",
          content: `
          <p>L'évolution récente de la conduite de projet est liée à l’informatique et aux possibilités nouvelles qu’elle offre en matière de stockage et de traitement des informations relatives au projet.
De nouveaux logiciels voient progressivement le jour pour faciliter la maîtrise des différentes composantes des projets.
À la fois expert en conduite de projet et en outils logiciels d’aide à cette conduite, FGFconsultant intervient activement dans la création des nouveaux outils.</p>`
        },
        {
          id: 4,
          title: "Identification des organisations, de la communication et des comportements pertinents",
          content: `<p>La conduite de projet exige la maîtrise de plusieurs paramètres qui obéissent à des lois et qui font de cette activité une science.
Mais le succès d’un projet passe aussi par la bonne prise en compte de la dimension humaine, dans la communication, la structuration et le partage des tâches, la compréhension des comportements, les pratiques commerciales, etc ...
FGFconsultant travaille, en collaboration avec des grandes écoles et universités, à l’amélioration de la prise en compte de cette dimension dans la conduite de projet.</p>`

        }
      ]
    }



  },
  en: {
    slogan: "Our ambition, the success of your projects!",
    tagline: `Your<span class= "partenaire" > Partner</span> in Project Management`,
    welcome: "Welcome to FGFconsultant, your trusted source for project management consulting, training, and research solutions. Our team of experts is here to guide you to success in your projects.",
    contact_us: "Tell us everything!",
    services: "The services we offer",
    services_subtitle:"Tailored services to guide and realize your ambitions",
    collaborations: "Collaborations that make a difference",
    success_story: "Our Success Story Through Partnerships",
    partners_space: "Welcome to our partner space for those who chose to grow with us. This gallery of logos represents more than past collaborations; it embodies strong and lasting relationships.",
    explore_projects: "Explore Our Projects Around the World",
    discover_map: "Discover FGFconsultant’s Global Reach with Our Interactive Map",
    why_fgf: "Why",
    commitment: "At FGFconsultant, we are committed to simplifying your project management and boosting your business growth. With years of expertise, cutting-edge tools, and a focus on your success, we’re your ideal partner. Project management becomes easy with us, and your success becomes our mission. Join us today to transform your business.",
    proven_expertise: "Proven Expertise",
    cutting_edge_software: "Cutting-Edge Software",
    full_transparency: "Full Transparency",
    custom_training: "Customized Training",
    dedication_success: "Commitment to Your Success",
    your_goals: "And you, what are your goals?",
    questions: "Questions?",
    footer_tagline: "FGFconsultant: Simplify project management, boost business growth, and make us your partner for success.",
    address: "Address",
    email: "Email",
    phone: "Phone number",
    copyright: "FGFconsultant@2023",
    legal: "Legal Notice",
    sitemap: "Sitemap",
    conseil: "Consulting",
    formation: "Training",
    recherche: "Research",
    liberte: "Freedom",
    voyage: "Travel",
    creativite: "Creativity",
    sport: "Sport",
    contactez_nous: "Contact us",
    title: "Contact us to bring your ideas to life!",
    description: "We’re here to answer all your questions and turn your projects into reality.",
    subText: "Let us help you achieve your goals.",
    send: "Send",
    lastName: "Last Name",
    firstName: "First Name",
    message: "message",

    items: [
      {
        id: 1,
        title: "Technical Assistance",
        content: `
        < ul >
            <li>Mastery of deadlines/scheduling</li>
            <li>OPC (Organization, Management & Coordination)</li>
            <li>Control of expenses/Cost tracking</li>
            <li>Risk management (Risk Manager)</li>
            <li>Control of product development process</li>
            <li>Overall project management expertise</li>
          </ul > `
      },
      {
        id: 2,
        title: "Project Manager Coaching",
        content: `
  < ul >
            <li>Project ownership (Maîtrise d'œuvre)</li>
            <li>Project sponsorship (Maîtrise d'ouvrage)</li>
          </ul > `
      },
      {
        id: 3,
        title: "Improvement of Your Practices",
        content: `
  < ul >
            <li>Process audit and recommendations</li>
            <li>Implementation of processes and documentation</li>
            <li>Selection of software tools or development oversight</li>
            <li>Deployment of software, interfaces, training</li>
          </ul > `
      },
      {
        id: 4,
        title: "Project Execution",
        content: `
  < ul >
            <li>Project owner (Maître d’œuvre)</li>
            <li>Industrial architect</li>
            <li>Delegate project sponsor</li>
            <li>Assistant to project sponsor</li>
          </ul > `
      },
      {
        id: 5,
        title: "Project Manager Training",
        content: `
  < ul >
            <li>Project Management: fundamentals (4 days)</li>
            <li>The role of the Project Manager (4 days)</li>
            <li>Project Management: client side roles (2 days)</li>
          </ul > `
      },
      {
        id: 6,
        title: "Project Management Training",
        content: `
  < ul >
            <li>Deadline control & scheduling (4 days)</li>
            <li>Cost control (4 days)</li>
            <li>Cost estimation for both management and sponsorship (4 days)</li>
            <li>Costing on management side (3 days)</li>
            <li>Project economic evaluation (2 days)</li>
            <li>Project risk management (2 days)</li>
            <li>Product development process mastery (3 days)</li>
            <li>Requirements specification (2 days)</li>
          </ul > `
      },
      {
        id: 7,
        title: "Project Execution Training",
        content: `
  < ul >
            <li>Managing large projects (5 days)</li>
            <li>Small projects: keys to success (2 days)</li>
          </ul > `
      },
      {
        id: 8,
        title: "Training in project software tools",
        content: `
  < ul >
            <li>Using MS Project: 3 levels (beginner, intermediate, expert), 2 days per level</li>
            <li>Using Primavera: 3 levels (beginner, intermediate, expert), 2 days per level</li>
            <li>Using Sciforma: 3 levels (beginner, intermediate, expert), 2 days per level</li>
          </ul > `
      }
    ],

    conseilSection: {
      title: "Consulting – Concrete Results",
      description:
        "We optimize your project management by providing solutions tailored to your needs.",
      subtitle: "Our Consulting Expertise",
      expertises: [
        {
          id: 1,
          title: "Process Optimization",
          content:
            "Structuring and improving your project management methodologies."
        },
        {
          id: 2,
          title: "Digitalization & Tools",
          content:
            "Deployment of software and digital solutions for higher performance and reduced costs."
        },
        {
          id: 3,
          title: "Operational Support",
          content:
            "Support for dedicated project teams and PMOs to help manage your projects."
        },
        {
          id: 4,
          title: "Project Execution",
          content:
            "Handling the project delivery and on-site execution, providing client-side assistance for your company or public institution."
        }
      ],
      missionsTitle: "Some Assignments",

      missions: [
        {
          id: 1,
          content: "Improvement of project management processes for a service company (8000 employees).",

        },
        {
          id: 2,
          content: "Implementation of a project framework for an aerospace company.",

        },
        {
          id: 3,
          content: "Optimization of document management in the nuclear sector.",

        },
        {
          id: 4,
          content: "Deployment of project management tools and team training for an industrial group.",

        },
        {
          id: 5,
          content: "Client-side support on several complex projects."

        },
        {
          id: 6,
          content:"Project management for several projects",
        }

      ],
      secteur: "Sectors of Intervention",
      quote: "Have any questions? Don’t hesitate to let us know",

      Conseil: [
        {
          id: 1,
          title: "Implementation or Improvement of Project Management Process",
          content: `<p>One of the major challenges at the end of the second millennium was to provide the populations of so-called "developed" countries with equipment and goods to improve their quality of life: better nutrition, more well-being, improved hygiene, better health, more leisure time, and therefore a greater openness to the world, to people, to social matters, to our planet, and to ecology... Institutions adapted to this challenge and adopted a new form of management suited for repetitive and sustainable activities. However, due to major projects in the space, nuclear, and medical sectors, and with the accelerated renewal of mass-produced goods, the need for project management reemerged. Additionally, with the rise of computing in the mid-20th century and the ability to store and process large amounts of data efficiently, a new approach to project management emerged. Today, many organizations face difficulties due to a gap between existing structures designed for repetitive work and the need for a modern management model tailored to projects.</p>
            <p>FGFconsultant specializes in Reengineering consulting. Based on an audit of your organization and aligned with your needs and management specificities, FGFconsultant can support your transition to a new management model by implementing:</p>
            <ul>
              <li>The necessary cultural and know-how additions</li>
              <li>New practices</li>
              <li>New processes</li>
            </ul>`
        },
        {
          id: 2,
          title: "Deployment or Evolution of a Software Solution",
          content: `<p>The mid-20th century saw the emergence of computing—the ability to store and process large volumes of data productively. In project management, this revolutionized processes and practices, and new software tools gradually emerged.</p>
            <p>FGFconsultant specializes in digital project management tools. Based on an audit of your current resources and aligned with your management specificities and goals, FGFconsultant can guide your project information system transformation, taking charge of:</p>
            <ul>
              <li>Software selection / RFP management</li>
              <li>Installation and configuration</li>
              <li>Migration and pilot project support</li>
              <li>Hotline support</li>
            </ul>`
        },
        {
          id: 3,
          title: "Project Owner and Contractor Support through Expertise",
          content: `<p>In agriculture, industry, and especially in the services sector, all organizations today face projects that require effective management.</p>
            <p>At the same time, especially when the organization’s main focus is mass production, the necessary project management resources are often missing or insufficient.</p>
            <p>FGFconsultant can handle components such as configuration, timelines, cost control, risk management, and communication. It can also take full charge of project control alongside your project manager, or manage the entire project. Thanks to its project management expertise, FGFconsultant also knows how to coach your team leaders so they can unlock their full potential for the benefit of your projects.</p>`
        },
        {
          id: 4,
          title: "FGFconsultant Project Contracting",
          content: `<p>Project management is both an art and a science. It is adapted to the project’s specificities and is governed by laws and principles—making it a science. Today, relevant project management cannot be achieved without understanding these principles.</p>
            <p>However, since most projects involve diverse domains like human sciences, business relationships, legal regulations, societal and environmental responsibility, systemic integration, and cultural harmony, project management is also an art.</p>
            <p>Managing or supervising a project is therefore a task that is both exciting and demanding. FGFconsultant handles all aspects of project execution—from beginning to end or for specific phases—either as the main contractor or as assistant to the client.</p>`
        }
      ]

      




    },

    formationSection: {
      title: "Training - Key Skills",
      description:
        "We design and deliver training tailored to your needs, whether you're a business, a public service, a grande école, a university, or a continuing education organization.",
      subtitle: "Our Training in Action",
      formations: [
        {
          id: 1,
          title: "Teaching Project Methods",
          content: "Training in best practices for project management."
        },
        {
          id: 2,
          title: "Tool-Based Training",
          content: "Learning how to use specialized software tools."
        },
        {
          id: 3,
          title: "Initial & Continuing Training",
          content: "Teaching in top schools and universities, companies, public services, and continuing professional education centers."
        },
        {
          id: 4,
          title: "Instructional Design & Facilitation",
          content: "Content creation: lectures, case studies, simulations. Facilitation of sessions, project simulations, certification preparation."
        }
      ],
      themesTitle: "Key Topics Taught",
      teachingTopics: [
        {
          content: "Project Management Fundamentals - Methodology, organization, and communication (3 to 6 days)"
        },
        {
          content: "Cost Estimation & Profitability Analysis - Databases, estimation methods, and NPV calculation (3 to 5 days)"
        },
        {
          content: "International Certifications - Preparation for PMI, IPMA, and ICEC certifications (5 to 20 days)"
        },
        {
          content: "Expenditure Control - Budgeting, earned value, and forecasting (3 to 5 days)"
        },
        {
          content: "Project Management Software Tools - Training in specialized tools (2 to 3 days)"
        },
        {
          content: "Risk Management - Analysis and mitigation, contingency budgeting, and reserves (1 to 3 days)"
        }
      ],
      secteur: "Areas of Intervention",
      quote: "Do you have any questions? Don't hesitate to let us know!",

      Formation: [
        {
          id: 1,
          title: "Teaching Methods and Interpersonal Skills in Project Management",
          content: `<p>Students and trainees now expect information delivered with high-quality presentation: varied, rich, and dynamic. Moreover, in a globalized economy with increasing performance demands—especially in project management—they need operational and relevant information. FGFconsultant adopts a modern teaching approach that blends formal, rigorously structured methods with varied and creative techniques. Additionally, with solid practical experience, FGFconsultant provides specific and illustrative examples. We offer project management training at French and international universities, elite engineering and business schools, and continuing education organizations. We also provide in-company training for public institutions and private companies.</p>`
        },
        {
          id: 2,
          title: "Learning How to Use Software Solutions",
          content: `<p>Since the mid-20th century, tools to support project management have been developed. Initially focused on scheduling tasks over time, these applications now allow control over all parameters needed to ensure project success. FGFconsultant masters several top-tier software tools and delivers training that combines technical know-how with project management expertise.</p>`
        },
        {
          id: 3,
          title: "Initial & Continuing Training",
          content: `
          <ul>
            <li><strong>Initial Training</strong> at leading universities and business schools in Francophone regions.</li>
            <li><strong>Inter-company Continuing Training</strong> for specialized organizations.</li>
            <li><strong>In-company Continuing Training</strong> within enterprises and local authorities.</li>
            <li><strong>Individual Training</strong>, tailor-made.</li>
          </ul>
          <p>Across all sectors, organizational performance increasingly depends on project outcomes. As a result, demand for qualified project managers is growing. Universities, business schools, and continuing education providers are integrating project management modules into their curricula. Companies and public sector organizations are also establishing internal training programs.</p>
          <p>FGFconsultant adapts its project management training to your needs, objectives, and learner profile. We offer high-quality specialized training programs to meet the growing demand for project management skills.</p>`
        },
        {
          id: 4,
          title: "Instructional Design & Facilitation: Simulations, Coaching, and Certification Prep",
          content: `<p>With economic globalization, organizations must deliver high–performance services, and individuals must demonstrate team integration and complementary expertise. Project management plays a crucial role in organizational success, yet many modern tools remain underutilized.</p>
          <p>Certification ensures quality competence and familiarity with terminology and standards, essential for clear communication among stakeholders.</p>
          <p>FGFconsultant offers certification preparation programs for both continuous and initial training. We regularly prepare candidates for certifications such as the Francophone Project Management Association (SMAP), IPMA Level D, and ICEC international project management certification exams.</p>`
        }
      ]
    },
    researchSection: {
      title: "Research – Meaningful Advances",
      description:
        "We use our expertise to improve project management methods and tools, thereby continuously enhancing the advice and training we provide.",
      subtitle: "Research and Innovation at the Core of Our Work",
      items: [
        {
          id: 1,
          title: "Innovation in Project Management",
          content: "As pioneers in the field, we develop new methods to tackle tomorrow's challenges."
        },
        {
          id: 2,
          title: "Strengthening Methodological Tools",
          content: "Our solutions help optimize your processes, reduce costs, and maximize outcomes."
        },
        {
          id: 3,
          title: "Development of Custom Digital Tools",
          content: "We design innovative software to simplify project management and monitoring."
        },
        {
          id: 4,
          title: "Organizational Optimization",
          content: "Assessment of current solutions, design and testing of alternatives in partnership with top schools and universities."
        }
      ],
      workTitle: "Selected Achievements",
      works: [
        { content: "Design of an optimized method for project cost control. More responsive, less expensive, more relevant.", },
        { content: "Development of the Project Documentation System (PDS). Exhaustive list and outlines of documents. Fewer changes in projects, making them cheaper and shorter.", },
        { content: "Development of software for managing actions and decisions. Improved management, communication, and traceability. Fewer errors, higher quality." }



      ],
      invitedTitle: "They Invited Us",

      quote: "Do you have any questions? Don't hesitate to let us know!",

      Recherche: [
        {
          id: 1,
          title: "Pioneer, FGFconsultant is already writing the future of Project Management",
          content: `<p>FGFconsultant plays an active role in various working groups of project management experts, aiming to better understand project specifics and design more effective management solutions.<br>
    François Gagné, president‑founder of FGFconsultant, led the expert group that, in collaboration with AFNOR (French Standardization Association) and AFITEP (Francophone Project Management Association), developed the X50‑137 “cost control for projects” guidance document in 2004–2005. This document remains the French reference for project cost management.<br>
    Acting as a natural bridge between academia—through training—and operational practice—through consulting—FGFconsultant supervises academic theses in two ways: by providing a research director to universities and grandes écoles, and by hosting interns within its team.</p>`
        },
        {
          id: 2,
          title: "Enhancing the Project Management Methodological Toolkit",
          content: `<p>Project management, by definition, is the type of management adapted to project-based productive activity. While 20th‑century management—focused on optimizing repetitive and long-term operations—was extensively developed, Project Management remains inconsistent and lacks overall coherence. FGFconsultant actively contributes to structuring pragmatic and effective Project Management.<br>
    This holistic approach is only operationally useful when supported by high-performance solutions to address all project management components. FGFconsultant contributes to developing specific methodological tools, including product and stakeholder breakdown structures, and schedule control solutions, among others.<br>
    The most advanced work focuses on cost control. To improve project economic performance—for project stakeholders and the broader community benefiting from reduced waste—FGFconsultant developed an optimized cost‑control method for project execution: the FGF “costenance” method. This simple, economical, and responsive method aligns with project launch strategies and minimizes economic uncertainties. Fully operational, it applies to all project types.</p>`
        },
        {
          id: 3,
          title: "Developing Software Solutions to Complement the Current Offer",
          content: `
          <p>The recent evolution in project management is linked to computing and its new capabilities for storing and processing project data.</p>
          <p>New software tools are gradually emerging to facilitate control of all project components.</p>
          <p>As both a project management and software tool expert, FGFconsultant is actively involved in creating these new tools.</p>`
        },
        {
          id: 4,
          title: "Identifying the Relevant Organizations, Communication and Behaviors",
          content: `<p>Project management requires mastery of several parameters governed by laws, making it a science.</p>
          <p>But project success also depends on properly addressing the human dimension—communication, task structuring and sharing, behavior understanding, business practices, etc...</p>
          <p>FGFconsultant works with grandes écoles and universities to improve consideration of this human dimension in project management.</p>`
        }
      ]
    }



  },
  esp: {
    slogan: "¡Nuestra ambición, el éxito de sus proyectos!",
    tagline: `Su <span class="partenaire" > Socio</span> en gestión de proyectos`,
    welcome: "Bienvenido a FGFconsultant, su fuente de confianza para soluciones de consultoría, formación e investigación en gestión de proyectos. Nuestro equipo de expertos está a su disposición para guiarle hacia el éxito de sus proyectos.",
    contact_us: "¡Cuéntenos todo!",
    services_subtitle:"Servicios personalizados para dirigir y hacer realidad sus ambiciones",
    services: "Los servicios que ofrecemos",
    collaborations: "Colaboraciones que marcan la diferencia",
    success_story: "Nuestra Historia de Éxito a Través de Alianzas",
    partners_space: "Bienvenido a nuestro espacio dedicado a los socios que han decidido crecer con nosotros. Esta galería de logotipos representa mucho más que colaboraciones pasadas; encarna relaciones sólidas y duraderas.",
    explore_projects: "Explorar Nuestros Proyectos por el Mundo",
    discover_map: "Descubra el Alcance Internacional de FGFconsultant con Nuestro Mapa Interactivo",
    why_fgf: "¿Por qué",
    commitment: "En FGFconsultant, nos comprometemos a simplificar su gestión de proyectos y a impulsar el crecimiento de su empresa. Nuestra experiencia, nuestros programas avanzados y nuestro compromiso con su éxito nos convierten en su socio ideal. Con nosotros, la gestión de proyectos es sencilla y su éxito es nuestra misión. ¡Únase hoy y transforme su negocio!",
    proven_expertise: "Experiencia Probada",
    cutting_edge_software: "Software de Punta",
    full_transparency: "Transparencia Total",
    custom_training: "Formación Personalizada",
    dedication_success: "Compromiso con su Éxito",
    your_goals: "¿Y usted, cuáles son sus objetivos?",
    questions: "¿Preguntas?",
    footer_tagline: "FGFconsultant: Simplifique la gestión de proyectos, impulse el crecimiento empresarial y conviértanos en su socio para el éxito.",
    address: "dirección",
    email: "correo electrónico",
    phone: "Número de teléfono",
    title: "¡Contáctanos para hacer realidad tus ideas!",
    description: "Estamos aquí para responder a todas tus preguntas y hacer realidad tus proyectos.",
    subText: "Déjanos ayudarte a alcanzar tus objetivos.",
    send: "Enviar",
    lastName: "Apellido",
    firstName: "Nombre",

    legal: "Aviso legal",
    sitemap: "Mapa del sitio",
    conseil: "Consultoría",
    formation: "Formación",
    recherche: "Investigación",
    liberte: "Libertad",
    voyage: "Viaje",
    creativite: "Creatividad",
    sport: "Deporte",
    contactez_nous: "Contáctenos",
    message: "mensaje",

    items: [
      {
        id: 1,
        title: "Asistencia Técnica",
        content: `
  < ul >
            <li>Dominio de plazos/planificación</li>
            <li>OPC (Organización, Dirección y Coordinación)</li>
            <li>Control de gastos/Cotización</li>
            <li>Gestión de riesgos (Risk Manager)</li>
            <li>Dominio del proceso de desarrollo del producto</li>
            <li>Experiencia global como jefe de proyecto</li>
          </ul > `
      },
      {
        id: 2,
        title: "Coaching para Jefe de Proyecto",
        content: `
  < ul >
            <li>Dirección de obra (Maîtrise d'œuvre)</li>
            <li>Dirección de contratos (Maîtrise d'ouvrage)</li>
          </ul > `
      },
      {
        id: 3,
        title: "Mejora de sus Prácticas",
        content: `
  < ul >
            <li>Auditoría de procesos y recomendaciones</li>
            <li>Implementación de procesos y documentación</li>
            <li>Selección de herramientas o supervisión del desarrollo</li>
            <li>Implementación de software, interfaces y formación</li>
          </ul > `
      },
      {
        id: 4,
        title: "Ejecución de su Proyecto",
        content: `
  < ul >
            <li>Jefe de obra (Maître d’œuvre)</li>
            <li>Arquitecto industrial</li>
            <li>Patrocinador delegado</li>
            <li>Asistente al patrocinador</li>
          </ul > `
      },
      {
        id: 5,
        title: "Formación de Jefe de Proyecto",
        content: `
  < ul >
            <li>Gestión de Proyectos: fundamentos (4 días)</li>
            <li>El rol del Jefe de Proyecto (4 días)</li>
            <li>Gestión de Proyectos: funciones de cliente (2 días)</li>
          </ul > `
      },
      {
        id: 6,
        title: "Formación en Gestión de Proyectos",
        content: `
  < ul >
            <li>Control de plazos/planificación (4 días)</li>
            <li>Control de costos (4 días)</li>
            <li>Estimación de costos (4 días)</li>
            <li>Estimación para dirección de obra (3 días)</li>
            <li>Evaluación económica de proyectos (2 días)</li>
            <li>Gestión de riesgos (2 días)</li>
            <li>Dominio del desarrollo del producto (3 días)</li>
            <li>Redacción de requisitos (2 días)</li>
          </ul > `
      },
      {
        id: 7,
        title: "Formación en Ejecución de Proyectos",
        content: `
  < ul >
            <li>Gestión de grandes proyectos (5 días)</li>
            <li>Proyectos pequeños: claves para el éxito (2 días)</li>
          </ul > `
      },
      {
        id: 8,
        title: "Formación en herramientas de software para proyectos",
        content: `
  < ul >
            <li>Uso de MS Project: 3 niveles (principiante, intermedio, avanzado), 2 días por nivel</li>
            <li>Uso de Primavera: 3 niveles (principiante, intermedio, avanzado), 2 días por nivel</li>
            <li>Uso de Sciforma: 3 niveles (principiante, intermedio, avanzado), 2 días por nivel</li>
          </ul > `
      }
    ],

    conseilSection: {
      title: "Consultoría – Resultados Concretos",
      description:
        "Optimizamos la gestión de sus proyectos ofreciendo soluciones adaptadas a sus necesidades.",
      subtitle: "Nuestras Experticias en consultoría",
      expertises: [
        {
          id: 1,
          title: "Optimización de procesos",
          content:
            "Estructuración y mejora de los métodos de gestión de sus proyectos."
        },
        {
          id: 2,
          title: "Digitalización y herramientas",
          content:
            "Implementación de software y soluciones digitales para mejorar el rendimiento y reducir costos."
        },
        {
          id: 3,
          title: "Acompañamiento operacional",
          content:
            "Apoyo a los equipos de proyecto dedicados y a los PMO para dirigir sus proyectos."
        },
        {
          id: 4,
          title: "Ejecución de proyecto",
          content:
            "Gestión de la entrega del proyecto y ejecución en campo, asistencia al cliente para su empresa o institución pública."
        }
      ],
      missionsTitle: "Algunas misiones",

      missions: [
        {
          id: 1,
          content: "Mejora de los procesos de gestión de proyectos para una empresa de servicios (8000 empleados).",


        },
        {
          id: 2,
          content: "Implementación de un marco de proyectos para una empresa aeroespacial.",


        },
        {
          id: 3,
          content: "Optimización de la gestión documental en el sector nuclear.",


        },
        {
          id: 4,

          content: "Despliegue de herramientas de gestión de proyectos y formación a equipos para un grupo industrial.",

        },
        {
          id: 5,
          content: "Asistencia al cliente en varios proyectos complejos."
        },
        {
          id: 6,
          content:"Dirección de obra de varios proyectos",
        }

      ],
      secteur: "Sectores de intervención",
      quote: "¿Tienes preguntas? No dudes en hacérnoslo saber",
      Conseil: [
        {
          id: 1,
          title: "Implementación o mejora del proceso de gestión de proyectos",
          content: `<p>Uno de los grandes desafíos a finales del segundo milenio fue dotar a los pueblos de los países “desarrollados” con equipamientos y bienes destinados a mejorar su calidad de vida: mejor nutrición, más bienestar, mayor higiene, mejor salud, más tiempo de ocio y una mayor apertura al mundo, a las personas, a lo social, al planeta y a la ecología... Las instituciones se organizaron y adoptaron una nueva forma de gestión adaptada a actividades repetitivas y sostenibles. Sin embargo, debido a grandes proyectos en el espacio, lo nuclear, la medicina y la renovación acelerada de productos, resurgió la necesidad de gestionar proyectos. Además, con la aparición de la informática en el siglo XX y la capacidad de almacenar y procesar grandes volúmenes de datos con buena productividad, surgió un nuevo modelo de gestión de proyectos. Actualmente, muchas organizaciones enfrentan dificultades debido a un desfase entre la estructura existente adaptada a tareas repetitivas y la necesidad de una gestión moderna basada en proyectos.</p>
            <p>FGFconsultant está especializado en consultoría de Reingeniería. A partir de una auditoría de su organización y en función de sus necesidades y especificidades de gestión, y conforme a sus objetivos, FGFconsultant puede guiar su cambio de modelo de gestión e implementar:</p>
            <ul>
              <li>Los complementos culturales y de conocimientos necesarios</li>
              <li>Nuevas prácticas</li>
              <li>Nuevos procesos</li>
            </ul>`
        },
        {
          id: 2,
          title: "Implantación o evolución de una solución de software",
          content: `<p>A mediados del siglo XX surgió la informática: la capacidad de almacenar y procesar grandes volúmenes de datos de manera eficiente. En el ámbito de la gestión de proyectos, esto transformó procesos y prácticas, y poco a poco surgieron nuevas herramientas digitales.</p>
            <p>FGFconsultant está especializado en herramientas digitales de gestión de proyectos. A partir de una auditoría de sus medios y según sus necesidades y objetivos, FGFconsultant puede liderar su transición de sistema de información para proyectos, asumiendo:</p>
            <ul>
              <li>Selección de software / gestión de licitaciones</li>
              <li>Instalación y configuración</li>
              <li>Migración y acompañamiento en proyectos piloto</li>
              <li>Soporte técnico</li>
            </ul>`
        },
        {
          id: 3,
          title: "Asistencia al Promotor y al Director de Obra mediante experiencia",
          content: `<p>En la agricultura, la industria y sobre todo en el sector servicios, todas las organizaciones enfrentan hoy proyectos que requieren una gestión eficaz.</p>
            <p>Al mismo tiempo, cuando la producción en serie es la prioridad, los recursos disponibles para gestionar proyectos suelen ser escasos o inexistentes.</p>
            <p>FGFconsultant puede encargarse de la configuración, los plazos, los costes, los riesgos y la comunicación. También puede supervisar el proyecto junto a su jefe de proyecto o gestionarlo por completo. Gracias a su experiencia, FGFconsultant puede también entrenar a sus responsables para que den lo mejor de sí en sus proyectos.</p>`
        },
        {
          id: 4,
          title: "Dirección de Obra de Proyecto con FGFconsultant",
          content: `<p>La gestión de proyectos es tanto una ciencia como un arte. Está adaptada a las especificidades de cada proyecto y regulada por principios que hacen de ella una disciplina científica. Hoy en día no se puede gestionar correctamente sin conocer estas leyes.</p>
            <p>Sin embargo, como la mayoría de los proyectos implican áreas como ciencias humanas, relaciones comerciales, derecho, responsabilidad social y medioambiental, integración sistémica y armonía cultural, la gestión de proyectos también es un arte.</p>
            <p>Gestionar o supervisar un proyecto es una tarea apasionante pero exigente. FGFconsultant puede encargarse de la gestión global del proyecto—desde el inicio hasta el cierre o en una fase concreta—ya sea como Director de Obra o como Asistente del Promotor.</p>`
        }
      ]
    },

    formationSection: {
      title: "Formación - Competencias Clave",
      description:
        "Diseñamos e impartimos formaciones adaptadas a sus necesidades, ya sea una empresa, un servicio público, una gran escuela, una universidad o una organización de formación continua.",
      subtitle: "Nuestras Formaciones en Acción",
      formations: [
        {
          id: 1,
          title: "Enseñanza de métodos",
          content: "Formación en buenas prácticas de gestión de proyectos."
        },
        {
          id: 2,
          title: "Formación en herramientas",
          content: "Aprendizaje en el uso de software especializado."
        },
        {
          id: 3,
          title: "Formación inicial y continua",
          content: "Intervenciones en grandes escuelas y universidades, empresas y servicios públicos, centros de formación profesional continua."
        },
        {
          id: 4,
          title: "Ingeniería pedagógica y animaciones",
          content: "Creación de contenidos: clases magistrales, estudios de caso, simulaciones. Animación de sesiones, preparación para certificaciones internacionales."
        }
      ],
      themesTitle: "Algunos temas impartidos",
      teachingTopics: [
        {
          content: "Fundamentos de la gestión de proyectos - Metodología, organización y comunicación (3 a 6 días)"
        },
        {
          content: "Estimación de costos y rentabilidad - Base de datos, métodos de estimación y cálculo del VAN (3 a 5 días)"
        },
        {
          content: "Certificaciones internacionales - Preparación para certificaciones PMI, IPMA y ICEC (5 a 20 días)"
        },
        {
          content: "Control del gasto - Presupuesto, valor ganado y trabajo restante (3 a 5 días)"
        },
        {
          content: "Soluciones de software de gestión de proyectos - Formación en herramientas especializadas (2 a 3 días)"
        },
        {
          content: "Gestión de riesgos - Análisis y control, presupuesto de contingencia y provisiones (1 a 3 días)"
        }
      ],
      secteur: "Sectores de intervención",
      quote: "¿Tiene alguna pregunta? ¡No dude en comunicárnoslo!",

      Formation: [
        {
          id: 1,
          title: "Enseñanza de métodos y habilidades interpersonales en gestión de proyectos",
          content: `<p>Los estudiantes y participantes hoy en día esperan que la información se presente con alta calidad: variada, enriquecedora y dinámica. Además, en una economía globalizada con exigencias crecientes—especialmente en gestión de proyectos—necesitan información operativa y relevante. FGFconsultant adopta una pedagogía moderna que combina métodos formales y estructurados con enfoques creativos y variados. Con sólida experiencia práctica, FGFconsultant proporciona ejemplos específicos e ilustrativos. Ofrecemos formación en gestión de proyectos en universidades francesas e internacionales, grandes escuelas de ingeniería y negocios, y organizaciones de formación continua. También ofrecemos formación interna para instituciones públicas y empresas privadas.</p>`
        },
        {
          id: 2,
          title: "Aprendizaje en el uso de soluciones de software",
          content: `<p>Desde mediados del siglo XX se desarrollaron herramientas para apoyar la gestión de proyectos. Inicialmente enfocadas en la programación de tareas, estas aplicaciones ahora permiten controlar todos los parámetros necesarios para el éxito del proyecto. FGFconsultant domina varias herramientas de software de primera línea y ofrece formación combinando conocimiento técnico y experiencia en gestión de proyectos.</p>`
        },
        {
          id: 3,
          title: "Formación inicial y continua",
          content: `
          <ul>
            <li><strong>Formación inicial</strong> en universidades y grandes escuelas francófonas.</li>
            <li><strong>Formación continua inter-empresas</strong> para organizaciones especializadas.</li>
            <li><strong>Formación continua intra-empresa</strong> en empresas y entidades públicas.</li>
            <li><strong>Formación individual</strong>, a medida.</li>
          </ul>
          <p>En todos los sectores, el rendimiento organizativo depende cada vez más del éxito de sus proyectos. Por ello, la demanda de gestores de proyectos capacitados está creciendo. Universidades, grandes escuelas y centros de formación continua están integrando módulos de gestión de proyectos en sus programas. Asimismo, empresas y organismos públicos están estableciendo programas de formación interna.</p>
          <p>FGFconsultant adapta su formación en gestión de proyectos según sus necesidades, objetivos y perfil del alumnado. Ofrecemos programas de formación especializados de alta calidad para cubrir la creciente demanda de competencias en gestión de proyectos.</p>`
        },
        {
          id: 4,
          title: "Diseño instruccional y facilitación: simulaciones, acompañamiento y preparación para certificaciones",
          content: `<p>Con la globalización económica, las organizaciones deben ofrecer servicios de alto rendimiento, y los individuos deben demostrar integración en equipos y experiencia complementaria. La gestión de proyectos juega un papel crucial en el éxito organizacional, aunque muchas herramientas modernas siguen infrautilizadas.</p>
          <p>La certificación garantiza competencia de calidad y familiaridad con terminología y estándares, esenciales para una comunicación clara entre las partes interesadas.</p>
          <p>FGFconsultant ofrece programas de preparación para certificaciones tanto en formación continua como inicial. Preparamos regularmente a candidatos para certificaciones como SMAP (Asociación Francófona de Gestión de Proyectos), IPMA Nivel D, y exámenes de certificación internacional ICEC.</p>`
        }
      ]
    },

    researchSection: {
      title: "Investigación – Avances Significativos",
      description:
        "Utilizamos nuestra experiencia para mejorar los métodos y herramientas de gestión de proyectos, y así perfeccionamos continuamente los consejos y la formación que ofrecemos.",
      subtitle: "Investigación e innovación en el centro de nuestras acciones",
      items: [
        {
          id: 1,
          title: "Innovación en gestión de proyectos",
          content: "Pioneros en el campo, desarrollamos nuevos métodos para afrontar los retos del mañana."
        },
        {
          id: 2,
          title: "Refuerzo de herramientas metodológicas",
          content: "Nuestras soluciones permiten optimizar sus procesos, reducir costos y maximizar resultados."
        },
        {
          id: 3,
          title: "Creación de herramientas digitales a medida",
          content: "Diseñamos software innovador para simplificar la gestión y el seguimiento de sus proyectos."
        },
        {
          id: 4,
          title: "Optimización de las organizaciones",
          content: "Evaluación de soluciones existentes, desarrollo y prueba de alternativas en colaboración con grandes escuelas y universidades."
        }
      ],
      workTitle: "Algunos trabajos realizados",
      works: [
        { content: "Elaboración de un método optimizado de control de gastos del proyecto. Más reactivo, menos costoso, más pertinente.", },
        { content: "Desarrollo del Sistema Documental del Proyecto (SDP). Lista exhaustiva de documentos y sus resúmenes. Menos modificaciones en los proyectos, por tanto, menos costosos y más breves.", },
        { content: "Desarrollo de un software para el control de acciones y decisiones. Mejor gestión, comunicación y trazabilidad. Menos errores, más calidad." },

      ],
      invitedTitle: "Nos han invitado",

      quote: "¿Tiene alguna pregunta? ¡No dude en comunicárnoslo!",
      Recherche: [
        {
          id: 1,
          title: "Pionero, FGFconsultant ya escribe el futuro de la Gestión de Proyectos",
          content: `<p>FGFconsultant participa activamente en diversos grupos de trabajo de expertos en gestión de proyectos, con el objetivo de comprender mejor las especificidades de los proyectos y diseñar soluciones de gestión más eficaces.<br>
    François Gagné, presidente-fundador de FGFconsultant, presidió el grupo de expertos que, en colaboración con AFNOR (Asociación Francesa de Normalización) y AFITEP (Asociación Francófona de Gestión de Proyectos), elaboró en 2004‑2005 el fascículo X50‑137 sobre control de costos de proyectos. Este documento sigue siendo la referencia francesa en gestión de costes de proyectos.<br>
    Actuando como puente natural entre la academia—mediante la formación—y la práctica operativa—a través de la consultoría—FGFconsultant supervisa tesis académicas de dos formas: proporcionando un director de investigación a universidades y grandes escuelas, y acogiéndo practicantes en su equipo.</p>`
        },
        {
          id: 2,
          title: "Mejora del arsenal metodológico de Gestión de Proyectos",
          content: `<p>La gestión de proyectos, por definición, es el tipo de gestión adaptado a la actividad productiva basada en proyectos. Mientras que la gestión del siglo XX—centrada en optimizar operaciones repetitivas y a largo plazo—fue ampliamente desarrollada, la Gestión de Proyectos aún carece de coherencia global. FGFconsultant contribuye activamente a estructurar una gestión de proyectos eficaz y pragmática.<br>
    Este enfoque holístico solo es útil si se apoya en soluciones de alto rendimiento para abordar todos los componentes de la gestión de proyectos. FGFconsultant contribuye al desarrollo de herramientas metodológicas específicas, incluyendo desglose de producto y de actores, y soluciones de control de cronograma, entre otras.<br>
    El trabajo más avanzado se centra en el control de costes. Para mejorar el rendimiento económico del proyecto—para los involucrados y la comunidad beneficiaria de la reducción de desperdicios—FGFconsultant desarrolló un método optimizado de control de costes durante la ejecución del proyecto: el método “costenance” FGF. Este método simple, económico y reactivo se alinea con las estrategias de lanzamiento del proyecto y minimiza las incertidumbres económicas. Totalmente operativo, se aplica a todo tipo de proyecto.</p>`
        },
        {
          id: 3,
          title: "Desarrollo de soluciones de software que complementan la oferta actual",
          content: `
          <p>La evolución reciente de la gestión de proyectos está vinculada a la informática y sus nuevas capacidades para almacenar y procesar datos de proyectos.</p>
          <p>Poco a poco surgen nuevas herramientas de software para facilitar el control de todos los componentes del proyecto.</p>
          <p>Como experto tanto en gestión de proyectos como en herramientas informáticas, FGFconsultant participa activamente en la creación de estos nuevos instrumentos.</p>`
        },
        {
          id: 4,
          title: "Identificación de organizaciones, comunicación y comportamientos adecuados",
          content: `<p>La gestión de proyectos exige dominar varios parámetros regidos por leyes, lo que la convierte en una ciencia.</p>
          <p>Pero el éxito de un proyecto también depende de considerar correctamente la dimensión humana: comunicación, estructuración y reparto de tareas, comprensión de comportamientos, prácticas comerciales, etc...</p>
          <p>FGFconsultant trabaja junto con grandes escuelas y universidades para mejorar la integración de esta dimensión humana en la gestión de proyectos.</p>`
        }
      ]
    }



  }
};









const i18n = new VueI18n({
  locale: 'fr',
  fallbackLocale: 'en',
  messages,
});

export default i18n;





